import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

/**
 * Admin-only gate. Allows only authenticated users with ROLE = ADMIN.
 * Family leads and family members are redirected to login — they have
 * no business in this admin panel.
 *
 * Note: the backend uses @PreAuthorize("hasRole('ADMIN')") so a 403 will
 * also be returned server-side. This guard just prevents the SPA from
 * even loading the admin shell for non-admins.
 */
@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.auth.isAuthenticated() && this.auth.isAdmin()) return true;
    this.router.navigateByUrl('/login');
    return false;
  }
}
